import {
  AspectRatio,
  Card,
  CardBody,
  Divider,
  Heading,
  Image,
  LinkBox,
  LinkOverlay,
  Text
} from "@chakra-ui/react";
import Link from "next/link";
import { Content } from "~/api/resources";
import { mediaUrl } from "~/lib/media";

type StoryCardProps = {
  story: Content;
};

export const StoryCard = ({ story }: StoryCardProps) => {
  const { id, lead_media, title, subtitle, slug } = story;
  const image = lead_media ? mediaUrl(lead_media) : undefined;
  return (
    <LinkBox
      as={Card}
      h={"100%"}
      w={{ base: "345px", md: "fill", lg: "auto" }}
      maxW={{ base: "80vw", md: "auto" }}
      variant="outline"
      sx={{
        border: "2px solid",
        borderColor: "grey.900",
        display: "flex",
        flexDir: "column",
        justifyContent: "flex-start",
        alignContent: "flex-start",
      }}
    >
      <AspectRatio ratio={2} overflow="hidden">
        <Image
          objectFit="cover"
          w={{ base: "100%" }}
          h={{ base: "233px", md: "50%" }}
          borderRadius="3px 3px 0px 0px"
          alt="Story"
          src={image}
        />
      </AspectRatio>

      <CardBody w="100%" p={{ base: "24px 20px", md: "32px 24px" }}>
        <LinkOverlay as={Link} href={`/stories/${slug || id}`}>
          <Heading
            fontSize={{ base: "xl", md: "2xl" }}
            fontWeight="regular"
            noOfLines={{ base: 2 }}
          >
            {title}
          </Heading>
        </LinkOverlay>
        {!!subtitle && (
          <>
            <Divider m={{ base: "24px 0px" }} />

            <Text
              color="gray.500"
              fontSize="md"
              fontWeight="thin"
              noOfLines={{ base: 2 }}
            >
              {subtitle}
            </Text>
          </>)}
      </CardBody>
    </LinkBox>
  );
};
